import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const asct = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜特定商取引法に基づく表示';
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "特定商取引法に基づく表示" }])}
      
      <div className="asct">
        <h2 id="contentsHead">特定商取引法に基づく表示</h2>
        <div className="box02">
          <h3>
            特定商取引法に基づき下記内容をホームページ上に明示いたします。
          </h3>
          <div className="box02Txt">
            <dl className="tokusho">
              <dt>販売事業者名</dt>
              <dd>エリアリンク株式会社</dd>
              <dt>販売事業者所在地</dt>
              <dd>〒101-0021 東京都千代田区外神田4-14-1 秋葉原UDXビル20階</dd>
              <dt>代表者または運営統括責任者</dt>
              <dd>林　尚道<br />鈴木　貴佳</dd>
              <dt>代表者または運営統括責任者（フリガナ）</dt>
              <dd>ハヤシ　ナオミチ<br />スズキ　ヨシカ</dd>
              <dt>連絡先／ホームページ</dt>
              <dd>
                <a href="https://www.arealink.co.jp/">
                  https://www.arealink.co.jp/
                </a>
              </dd>
              <dt>連絡先／電子メール</dt>
              <dd>
                <a href="mailto:info@arealink.co.jp">info@arealink.co.jp</a>
              </dd>
              <dt>連絡先／TEL</dt>
              <dd>03-3526-8555</dd>
              <dt>販売価格帯</dt>
              <dd>当サイト上で表示されている料金</dd>
              <dt>商品等の引き渡し時期</dt>
              <dd>お客様ご指定日</dd>
              <dt>代金の支払時期および方法</dt>
              <dd>
                クレジットカード(JCB/VISA/MASTER/AMEX)、コンビニ、銀行振込み、現金
              </dd>
              <dt>商品代金以外に必要な費用 </dt>
              <dd>事務手数料、保証金、管理費など</dd>
              <dt>解約条件</dt>
              <dd>解約申込の翌月末日解約</dd>
              <dt>不良品の取扱条件</dt>
              <dd>
                不良・品違いがあった場合は、受付窓口へご連絡ください。
                <br />
                すぐに対応させていただきます。
              </dd>
              <dt>キャンセルについて</dt>
              <dd>
                ご契約後にキャンセルの場合はキャンセル料が発生いたします。
                <br />
                （１契約あたり5,000円(税込み））
              </dd>
              <dt>販売予定商品の説明</dt>
              <dd>
                <a href="https://www.arealink.co.jp/service/">
                  https://www.arealink.co.jp/service/
                </a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/asct.jsx